import React from 'react';
import SocialMediaCluster from '../../Miscs/SocialMediaCluster/SocialMediaCluster';

const FooterSocialMedia = () => {
	return (
		<>
			<div className="footer-social-media">
				<ul>
					<SocialMediaCluster />
				</ul>
			</div>
		</>
	);
};

export default FooterSocialMedia;
